<template>
  <div :class="computedClasses" />
</template>

<script setup lang="ts">
import type { ModalBackgroundVariant } from './types'

const props = withDefaults(defineProps<{
  variant?: ModalBackgroundVariant
}>(), {
  variant: 'dark',
})

const computedClasses = computed(() => ([
  'fixed inset-0',
  { 'bg-primary-950/80 backdrop-blur-xs': props.variant === 'dark' },
  { 'bg-gray-200/75 backdrop-blur-xs': props.variant === 'light' },
  { 'bg-transparent': props.variant === 'transparent' },
]))
</script>
